import { Slot } from '@radix-ui/react-slot';
import { ComponentProps } from 'react';

import { mergeClasses } from '@/utils';

import { BADGE_VARIANTS } from './Badge.constants';

export interface IBadge extends ComponentProps<'span'> {
  asChild?: boolean;
  size?: 'sm' | 'default' | 'md';
  borderRadius?: 'rounded' | 'soft';
  mode?: 'normal' | 'light';
  border?: boolean;
  variant?:
    | 'primary'
    | 'red'
    | 'orange'
    | 'yellow'
    | 'lime'
    | 'green'
    | 'teal'
    | 'cyan'
    | 'blue'
    | 'indigo'
    | 'violet'
    | 'grape'
    | 'pink'
    | 'transparent'
    | 'neutral-0'
    | 'neutral-1'
    | 'neutral-2'
    | 'neutral-3'
    | 'neutral-4'
    | 'neutral-5'
    | 'neutral-6'
    | 'neutral-7'
    | 'neutral-8'
    | 'neutral-9'
    | 'neutral-10';
}

export const Badge = ({
  className,
  variant = 'primary',
  size = 'default',
  borderRadius = 'rounded',
  mode = 'normal',
  border = false,
  asChild = false,
  ...props
}: IBadge) => {
  const Component = asChild ? Slot : 'span';

  return (
    <Component
      data-slot="badge"
      className={mergeClasses(
        BADGE_VARIANTS({ variant, size, borderRadius, mode, border }),
        className,
      )}
      {...props}
    />
  );
};
